/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { RecognitionMetadata } from './recognition-metadata';
// May contain unused imports in some cases
// @ts-ignore
import type { RecognitionResult } from './recognition-result';

/**
 *
 * @export
 * @interface AddTranscript
 */
export interface AddTranscript {
  /**
   *
   * @type {string}
   * @memberof AddTranscript
   */
  message: AddTranscriptMessageEnum;
  /**
   * Speechmatics JSON output format version number.
   * @type {string}
   * @memberof AddTranscript
   */
  format?: string;
  /**
   *
   * @type {RecognitionMetadata}
   * @memberof AddTranscript
   */
  metadata: RecognitionMetadata;
  /**
   *
   * @type {Array<RecognitionResult>}
   * @memberof AddTranscript
   */
  results: Array<RecognitionResult>;
}

export const AddTranscriptMessageEnum = {
  AddTranscript: 'AddTranscript',
} as const;

export type AddTranscriptMessageEnum =
  (typeof AddTranscriptMessageEnum)[keyof typeof AddTranscriptMessageEnum];
